import React, { FC } from 'react';
import { connect } from 'react-redux';
import {  getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { View } from 'react-native';
import { DETAILS_SCREENS_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import BatchTimeLine from '@v2/pages/batch/details/modules/batch/components/BatchTimeline/BatchTimeline';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { isWeb } from '@helpers';
import { fullWidth, width } from '@components/frame';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';

interface ProductionOrderDetailsBatchTimelineProps extends ProductionOrderScreenProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const ProductionOrderDetailsBatchTimelineComponent: FC<ProductionOrderDetailsBatchTimelineProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  productionOrdersSearch,
  batch,
  loadSingleBatch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    updateHeaderConfig,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <View
        style={{
          ...DETAILS_SCREENS_CONTAINER_STYLES,
          marginInline: 'auto',
          width: '100%',
        }}
      >
        <BatchTimeLine
          productionBatchId={batch?.data?.productionBatchId ?? undefined}
          width={isWeb ? fullWidth : width}
          withoutList
          horizontalOffset={SCREEN_PADDING_HORIZONTAL * 2}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsBatchTimeline = connect(({ batch: { batch } }) => ({ batch }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsBatchTimelineComponent);

export { ProductionOrderDetailsBatchTimeline };
